import { reportsRetrieveOptions } from '@crm/api'
import {
  ChartTypes,
  DynamicChart,
  DynamicTable
} from '@crm/features/reports/components'
import { useQuery } from '@tanstack/react-query'
import { Divider, Result, Spin } from 'antd'
import { useParams } from 'react-router-dom'

export const GenericReport = () => {
  const { id } = useParams()

  const { data, isLoading, isFetching } = useQuery({
    ...reportsRetrieveOptions({
      path: {
        id: Number(id)
      }
    }),
    enabled: !!id
  })

  if (isLoading || isFetching) {
    return <Spin />
  }

  return data?.chart_type ? (
    <>
      <DynamicTable id={id} />
      {!!data?.groups?.length && (
        <>
          <Divider />
          <DynamicChart
            chartType={data?.chart_type as ChartTypes}
            id={id}
            label="Chart"
            xAxy="name"
          />
        </>
      )}
    </>
  ) : (
    <Result
      status="warning"
      title="There are some problems with generating the report!"
      subTitle="Please check and modify the report or contact support for help."
    />
  )
}
